import { useFetch } from "src/hooks/useFetch";
import { SearchResultsService } from "src/services";
import { ProjectSearchResult } from "src/types";

export default function useGetProjectsSearchResults() {
  const [
    projectsSearchResultsState,
    fetchProjectsSearchResults,
    abortProjectsResultsFetch,
  ] = useFetch<ProjectSearchResult[]>();

  const handleFetchProjectsSearchResults = (
    wsWorkspaceUuid: string,
    queryData?: string[],
  ) => {
    fetchProjectsSearchResults((signal) =>
      SearchResultsService.getProjects(wsWorkspaceUuid, queryData, signal),
    );
  };

  const initializeProjectsSearchResultsFetch = (
    wsWorkspaceUuid: string,
    queryData?: string[],
  ) => {
    abortProjectsResultsFetch();
    handleFetchProjectsSearchResults(wsWorkspaceUuid, queryData);
  };

  return [
    projectsSearchResultsState,
    initializeProjectsSearchResultsFetch,
  ] as const;
}
